const {userAgent: ua} = navigator;

function isMobile() {
  return /(iphone|ipad|ipod|android)/i.test(ua);
}

function isIOS() {
  return /(iphone|ipad|ipod)/i.test(ua);
}

function isAndroid() {
  return /(android)/i.test(ua);
}

function isWX() {
  return /(micromessenger)/i.test(ua);
}

function isQQ() {
  return /(mqqbrowser|qq)/i.test(ua);
}

function isWB() {
  return /(weibo)/i.test(ua);
}

function isSafari() {
  return /(safari)/i.test(ua) && !/(chrome)/i.test(ua);
}

export {isMobile, isIOS, isAndroid, isWX, isQQ, isWB, isSafari}


// WEBPACK FOOTER //
// ./src/tools/lib/ua.js